<template>
  <v-list dense nav class="px-0">
    <div class="px-2">
      <v-list-item
        v-for="(item, i) in itens_avulsos"
        :key="i"
        :href="item.href"
        target="_blank"
        @click="redirect(item.way, $event)"
        :class="isActive(item.way)"
      >
        <v-tooltip right>
          <template v-slot:activator="{ on, attrs }">
            <v-list-item-icon>
              <v-icon color="bluePcm" v-bind="attrs" v-on="on">{{
                item.icon
              }}</v-icon>
            </v-list-item-icon>
          </template>
          <span>{{ item.message }}</span>
        </v-tooltip>
        <v-list-item-title class="ml-n4">{{ item.title }}</v-list-item-title>
      </v-list-item>
    </div>
  </v-list>
</template>

<script>
import { obtainUserPermissions } from "@/utils/obtainUserPermissions";
import { goToSelectedPath } from "@/utils/commomMethods/goToSelectedPath";

import {
  permissoesPerfil,
  permissoesUsuarios,
  permissoesAuditoria,
  permissoesToken,
} from "../utils/permissoesUsuarios";

export default {
  name: "ListNavigationDrawerUser",
  data: () => ({
    rotaSelecionada: "",
    itens_avulsos: [],
    permissionAuditoria: false,
    permissionPerfil: false,
    permissionToken: false,
    permissionUsuario: false,
  }),

  created() {
    const arrayPermissions = this.arrayPermissionsFromLocalStorage();

    arrayPermissions.forEach((permissionLocalStorage) => {
      if (
        permissoesAuditoria.includes(permissionLocalStorage) &&
        !this.permissionAuditoria
      ) {
        this.permissionAuditoria = true;
        this.itens_avulsos.push({
          title: "Auditoria",
          way: "Audit",
          icon: "mdi-account-tie",
          message: "Auditoria",
          href: "/controle-de-acesso/auditoria",
        });
      }

      if (
        permissoesPerfil.includes(permissionLocalStorage) &&
        !this.permissionPerfil
      ) {
        this.permissionPerfil = true;
        this.itens_avulsos.push({
          title: "Perfis",
          way: "Perfil",
          icon: "mdi-card-account-phone",
          message: "Cadastro de Perfil",
          href: "/controle-de-acesso/roles",
        });
      }

      if (
        permissoesToken.includes(permissionLocalStorage) &&
        !this.permissionToken
      ) {
        this.permissionToken = true;
        this.itens_avulsos.push({
          title: "Tokens",
          way: "TokenHome",
          icon: "mdi-account-key",
          message: "Cadastro de Token",
          href: "/controle-de-acesso/token",
        });
      }

      if (
        permissoesUsuarios.includes(permissionLocalStorage) &&
        !this.permissionUsuario
      ) {
        this.permissionUsuario = true;
        this.itens_avulsos.push({
          title: "Usuários",
          way: "UserHome",
          icon: "mdi-account-plus",
          message: "Cadastro Usuário",
          href: "/controle-de-acesso/home",
        });
      }
    });
  },

  methods: {
    ...goToSelectedPath,
    ...obtainUserPermissions,
     isActive(rota) {
      if (rota == this.$route.name) {
        this.rotaSelecionada = rota
        return "indigo lighten-5";
      } else if (rota == this.rotaSelecionada) {
        return "indigo lighten-5";
      }
    },
  },
};
</script>
